import { NavLayout } from '../enum/EnumRepository';

/** Fixed 레이아웃 배포 전까지 표시와 설정 UI를 비활성화한다. */
export const ENABLE_FIXED_NAV_LAYOUT = false;
export const DEFAULT_NAV_LAYOUT = NavLayout.FOLD;

export const resolveNavLayout = (
  value: NavLayout | null | undefined,
): NavLayout => {
  if (value === NavLayout.FIXED) {
    return NavLayout.FIXED;
  }
  if (value === NavLayout.FOLD) {
    return NavLayout.FOLD;
  }
  return DEFAULT_NAV_LAYOUT;
};
